<template>
  <app-layout>
    <div class="page-booking-confirmation">
      <section class="page-section bg-white">
        <div class="container mx-auto">
          <h1 class="heading-1 text-center">{{ $t(title) }}</h1>
          <p class="sub-headline text-center mt-1 xl:mt-3">{{ $t(subHeadline) }}</p>
          <app-card-confirmation class="mt-12"></app-card-confirmation>
        </div>
      </section>
      <app-banner-blog :destination="booking.destinationCode">{{ booking }}</app-banner-blog>
      <section class="bg-white" data-section-name="favorite-destinies">
        <app-destinies-container :title="$t('shared.destinations_one_day')"
          :btnLabel="$t('shared.discover_destinations')"></app-destinies-container>
      </section>
      <app-banner-gift></app-banner-gift>
      <app-banner-newsletter class="bg-palegray"></app-banner-newsletter>
    </div>
    <snackbar-component></snackbar-component>
  </app-layout>
</template>

<script lang="ts">
import { mapActions, mapGetters } from 'vuex';
import { GET_RESERVATION } from '../store/booking/getter-types';
import { RESET_BOOKING_STATE } from '../store/booking/mutation-types';
import { FETCH_PLACES } from '../store/destinies/action-types';
export default {
  data: function () {
    return {
      title: "shared.reservation_confirmed",
      subHeadline:
        "shared.weve_sent_you_an_email",
      loading: false,
      activeStep: 1
    };
  },
  computed: {
    ...mapGetters({
      booking: GET_RESERVATION,
    }),
  },
  methods: {
    ...mapActions({
      fetchPlaces: FETCH_PLACES
    }),
    goToStep(stepNumber) {
      this.activeStep = stepNumber;
    },
    handleStepComplete() {
      this.activeStep = this.activeStep === 4 ? 1 : this.activeStep + 1;
    }
  },
  created() {
    this.fetchPlaces().catch(() => {
      this.$toastr.e(
        "Ha ocurrido un error durante la búsqueda. Inténtalo nuevamente."
      );
    });
  },
  beforeDestroy() {
    this.$store.commit(RESET_BOOKING_STATE);
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/variables";

.sub-headline {
  font-family: $avenirHeavy;
  font-size: 16px;
}

.page-booking-confirmation {
  .page-section {
    padding: 2rem 0;
  }
}

@media screen and (min-width: 1280px) {
  .page-booking-confirmation {
    .page-section {
      padding: 6.25rem 0;

      .grid-cards {
        margin: 2.5rem 0 3rem;
      }
    }
  }
}
</style>
